import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import $ from 'jquery'
import 'bootstrap4-duallistbox'
import 'bootstrap4-duallistbox/dist/bootstrap-duallistbox.css'
import duallistboxConfig from '../../commons/duallistbox/DuallistboxConfig.js'
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Security from '../../commons/security/Security.js'
import Loading from '../ui/Loading.js'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';
import { getPermissionComponent } from "../../commons/utils/Multilanguage"
import PerfilesAsignacion from './PerfilesAsignacion.jsx'

class PerfilesAbm extends Component {
	constructor(props) {
		super(props);
		this.ajaxHandler = new AjaxHandler();

		this.state = {
			redirectTo: null,
			props: this.props,
			formData: {
				id: 0,
				nombre: '',
				permisos: [],
				perfiles_asignables: []
			},
			permisosDisponibles: [],
			permisosExcluyentes: [],
			arrayExcluyentes: [],
			permisosEliminados: [],
			perfilesDisponibles: [],
			esInterno: false,
			errors: [],
			loading: false
		};

		

		this.handleFormChange = this.handleFormChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handlePerfilesChange = this.handlePerfilesChange.bind(this);
		this.initPerfilesAsignablesDuallistbox = this.initPerfilesAsignablesDuallistbox.bind(this);

		this.formValidation = new FormValidation({
			component: this,
			validators: {
				'formData.nombre': (value) => Validator.notEmpty(value)
			}
		});
	}

	componentDidMount() {
		if ((Security.hasPermission('PERFILES_CREAR') && this.state.props.action === 'ADD') ||
			(Security.hasPermission('PERFILES_DUPLICAR') && this.state.props.action === 'DUPLICATE') ||
			(Security.hasPermission('PERFILES_MODIFICAR') && this.state.props.action === 'EDIT') ||
			(Security.hasPermission('PERFILES_VISUALIZAR') && this.state.props.action === 'VIEW')) {
			this.ajaxHandler.subscribe(this);
			this.initForm();
		} else {
			this.setState({
				redirectTo: '/error'
			});
		}
	}

	componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
	}

	/**
	 * Inicializa el duallistbox de perfiles asignables.
	 * Se usa desde initForm (EDIT/DUPLICATE) y desde componentDidUpdate (ADD cuando se agrega el permiso).
	 */
	initPerfilesAsignablesDuallistbox() {
		if (!this.refs.perfilesAsignablesDuallistbox) return;

		const $el = $(this.refs.perfilesAsignablesDuallistbox);
		if ($el.data('bootstrapDualListbox')) return;

		const perfilesAsignablesConfig = {
			moveOnSelect: false,
			moveAllLabel: this.props.intl.formatMessage({ id: 'duallisboxConfig.title_mover_todos', defaultMessage: 'Mover todos' }),
			removeAllLabel: this.props.intl.formatMessage({ id: 'duallisboxConfig.title_remover_todos', defaultMessage: 'Remover todos' }),
			moveSelectedLabel: this.props.intl.formatMessage({ id: 'duallisboxConfig.title_mover_seleccionados', defaultMessage: 'Mover seleccionados' }),
			removeSelectedLabel: this.props.intl.formatMessage({ id: 'duallisboxConfig.title_remover_seleccionados', defaultMessage: 'Remover seleccionados' }),
			infoText: false,
			filterPlaceHolder: this.props.intl.formatMessage({ id: 'duallisboxConfig.placeHolder_filtros', defaultMessage: 'Filtros' }),
			nonSelectedListLabel: this.props.intl.formatMessage({ id: 'duallisboxConfig.label_perfiles_disponibles', defaultMessage: 'Perfiles Disponibles' }),
			selectedListLabel: this.props.intl.formatMessage({ id: 'duallisboxConfig.label_perfiles_asignables', defaultMessage: 'Perfiles Asignables' })
		};

		$el.bootstrapDualListbox(perfilesAsignablesConfig);

		// Esperar al siguiente frame para que el DOM del duallistbox esté layoutado
		new Promise(resolve => requestAnimationFrame(resolve)).then(() => {
			if (this.perfilesAsignacionRef && this.perfilesAsignacionRef.updateEmptyMessage) {
				this.perfilesAsignacionRef.updateEmptyMessage();
			}
		});

		$el.change(() => {
			let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
			formDataCopy.perfiles_asignables = $el.val() || [];
			this.setState({
				formData: formDataCopy
			}, () => {
				$el.bootstrapDualListbox('refresh', true);
				if (this.perfilesAsignacionRef) {
					this.perfilesAsignacionRef.updateEmptyMessage();
				}
			});
		});
	}

	componentDidUpdate(prevProps, prevState) {
		// Solo nos importa este comportamiento en pantallas de alta/edición
		if (this.props.action !== 'ADD' && this.props.action !== 'EDIT') {
			return;
		}
		// Y solo si la persona logueada es interna
		if (!this.state.esInterno) {
			return;
		}

		const prevPerms = (prevState.formData && prevState.formData.permisos) ? prevState.formData.permisos : [];
		const currPerms = (this.state.formData && this.state.formData.permisos) ? this.state.formData.permisos : [];

		const prevTeniaPermiso =
			prevPerms.indexOf('PERFILES_LISTAR') !== -1 ||
			prevPerms.indexOf('PERFILES_VISUALIZAR') !== -1;

		const ahoraTienePermiso =
			currPerms.indexOf('PERFILES_LISTAR') !== -1 ||
			currPerms.indexOf('PERFILES_VISUALIZAR') !== -1;

		// Caso clave: antes NO lo tenía y ahora SÍ lo tiene → inicializar dual listbox de perfiles asignables
		if (!prevTeniaPermiso && ahoraTienePermiso) {
			this.initPerfilesAsignablesDuallistbox();
		}
	}

	initForm() {
		this.setState({ loading: true });
		let component = this;
		Promise.all([
			this.ajaxHandler.getJson('/permisos'),
			this.state.props.action !== 'ADD' ? this.ajaxHandler.getJson('/perfiles/' + this.state.props.match.params.id) : null,
			this.ajaxHandler.getJson('/permisos-excluyentes'),
			this.ajaxHandler.getJson('/perfiles'),
			this.ajaxHandler.getJson('/personas/simple-search/mi-usuario'),
		]).then((data) => {
			let permisosDisponibles = data[0];			
			let formData = data[1];
			if(this.state.props.action === 'DUPLICATE') {
				formData.nombre = ''
			}
			let permisosExcluyentes = data[2];
			let arrayExcluyentes = [];
			let i=0;
			for(var key in permisosExcluyentes) {
				arrayExcluyentes[i]= key;
				i++;
			};
			let perfilesDisponibles = data[3];
			let personaActual = data[4];

			// is_internal viene de la persona logueada en la DB
			const esInterno = personaActual && (personaActual.is_internal === 1 || personaActual.is_internal === true);

			component.setState({
				permisosDisponibles: permisosDisponibles,
				permisosExcluyentes: permisosExcluyentes,
				arrayExcluyentes: arrayExcluyentes,
				perfilesDisponibles: perfilesDisponibles,
				esInterno: esInterno,
			});
			if(formData) {
				// Inicializar perfiles_asignables si no existe
				if(!formData.perfiles_asignables) {
					formData.perfiles_asignables = [];
				}
				component.setState({
					formData: formData
				});
			}

			$(this.refs.duallistbox).bootstrapDualListbox(duallistboxConfig(this.props.intl));

			$(this.refs.duallistbox).change((e) => {
				$(this.refs.duallistbox).find("*").prop("disabled",false);
				let excluir = this.state.arrayExcluyentes.filter(x => $(this.refs.duallistbox).val().includes(x));
				excluir.forEach(excluyente => {
					this.state.permisosExcluyentes[excluyente].forEach(element => {
						$('#permisos option[value='+element+']').prop("disabled",true);
					});
				});

				let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
				formDataCopy.permisos = $(this.refs.duallistbox).val();
				this.setState({
					formData: formDataCopy
				}, ()=>{ $(this.refs.duallistbox).bootstrapDualListbox('refresh', true);});
			});
			
			//se necesita en el edit para deshabilitar las opciones excluyentes
			if(this.state.props.action === 'EDIT' || this.state.props.action === 'DUPLICATE'){
				let permisosAntes = $(this.refs.duallistbox).val();
				$(this.refs.duallistbox).change();
				let permisosDespues = $(this.refs.duallistbox).val();
				this.state.permisosEliminados = permisosAntes.filter(x => !permisosDespues.includes(x));
			}

			// Inicializar dual listbox para perfiles asignables si el ref existe (EDIT/DUPLICATE)
			this.initPerfilesAsignablesDuallistbox();
		}).catch(function(error) {
			console.log(error);
			component.exit();
		}).finally(() => {
			this.setState({ loading: false });
		});

		window.scrollTo(0, 0);
    	$('#nombre').focus();
	}

	handleFormChange(event) {
		const target = event.target;
		const name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[name] = value;
		this.setState({
			formData: formDataCopy
		});
	}

	handlePerfilesChange(event) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.perfiles_asignables = Array.from(event.target.selectedOptions, option => option.value);
		this.setState({
			formData: formDataCopy
		});
	}

	functionResolvePermissionLang(estado){
		if (backendStrings['tickets.estado.'+estado]){
		} else {
			return estado
		}
	}
	handleSubmit(event) {
		this.setState({ loading: true });
		let component = this
		let action = (this.props.action === 'ADD' || this.props.action === 'DUPLICATE') ? true : false

		// perfiles_asignables: leer del DOM desde el select interno del plugin (box2)
		// así funciona igual en POST y PUT aunque el estado no se haya sincronizado
		let perfilesAsignables = (this.state.formData.perfiles_asignables && Array.isArray(this.state.formData.perfiles_asignables))
			? this.state.formData.perfiles_asignables
			: [];
		const $container = $('#perfiles_asignables').prev('.bootstrap-duallistbox-container');
		if ($container.length && $container.find('.box2 select').length) {
			perfilesAsignables = $container.find('.box2 select option').map(function() { return $(this).val(); }).get();
		}

		const formDataToSend = {
			...this.state.formData,
			perfiles_asignables: perfilesAsignables
		};

		this.ajaxHandler.fetch('/perfiles' + (action ? '' : '/' + this.state.formData.id), {
			method: action ? 'POST' : 'PUT',
			body: JSON.stringify(formDataToSend),
		}).then(response => {
			if(response.status !== 400) {
				if(response.status === 204) { // TODO: Se podría reemplazar por un WebSocket que actualice los permisos del usuario logueado.
					let persona = JSON.parse(localStorage.getItem("persona"));
					if(persona.usuario.perfil.id === this.state.formData.id) {
						persona.usuario.perfil.permisos = this.state.formData.permisos;
						localStorage.setItem('persona', JSON.stringify(persona));
					}
				}
				component.exit();
			} else {
				response.json()
				.then(data => {
					this.setState({
						errors: data.detalle
					});
				});
			}
			window.scrollTo(0,0);
		}).catch((error) => {
			component.ajaxHandler.handleError(error);
		}).finally(() => {
			this.setState({ loading: false });
		});

		event.preventDefault();
	}

	handleCancel(event) {
		this.exit();
	}

	exit() {
		this.setState({
			redirectTo: '/perfiles'
		});
	}

	render() {
		this.formValidation.validate();
		let formData = this.state.formData;
		let validationState = this.formValidation.state;
		let requiredSymbol = this.state.props.action !== 'VIEW' ? ' *' : '';
		// Permisos del perfil que se está editando/creando
		const permisosPerfil = (formData && formData.permisos) ? formData.permisos : [];
		// Persona logueada (se usa para verificar si es interno) - viene de la DB (initForm)
		const esInterno = this.state.esInterno;

		const puedeAsignarPerfiles =
			esInterno &&
			(permisosPerfil.indexOf('PERFILES_LISTAR') !== -1 ||
			 permisosPerfil.indexOf('PERFILES_VISUALIZAR') !== -1); // permisos de perfiles que se están editando/creando
		let component = this
		return (
			<React.Fragment>
				{this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
				{this.state.loading && <Loading />}
				<div className="row">
					<div className="col-md-12">
						<div className="alert alert-danger" role="alert" hidden={this.state.errors.length===0}>
							{this.state.errors.map((e, i) => <li key={i}><FormattedMessage {...(backendStrings[e] ? backendStrings[e] : backendStrings['errors.default'])}/></li>)}
						</div>
						<form className="form form-horizontal" ref="form" onSubmit={this.handleSubmit}>
							<div className="form-body">
								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body">
											<h4 className="form-section">
												<i className="ft-user"></i><FormattedMessage id="perfilesAbm.render.general_data.header_datos_generales" defaultMessage=" Datos Generales"/>
												<div className="float-right" style={{fontSize:'14px'}}><FormattedMessage id="perfilesAbm.render.general_data.campos_requeridos" defaultMessage="* campos requeridos"/></div>
											</h4>
											<div className="row">
												<div className="col-md-12">
													<div className="form-group">
														<label htmlFor="nombre">
															<FormattedMessage id="perfilesAbm.render.general_data.label_perfil" defaultMessage="Perfil"/>{requiredSymbol}: {this.props.action === 'VIEW' ? formData.nombre : ''}
														</label>
														<div className="col-md-10">
															{this.props.action !== 'VIEW' ? (
															<div>
																<input type="text" className="form-control" id="nombre" name="nombre" placeholder={this.props.intl.formatMessage({ id: 'perfilesAbm.render.general_data.placeholder_perfil', defaultMessage: 'Nombre del Perfil' })} value={formData.nombre} onChange={this.handleFormChange} />
																<div className="help-block text-danger" hidden={validationState.formData.nombre.pristine || validationState.formData.nombre.valid}>{validationState.formData.nombre.message}</div>
																{this.state.permisosEliminados.length > 0 ? (
																<div className="mt-2">
																	<div class="alert alert-danger" role="alert">
																	{this.props.intl.formatMessage({ id: 'perfilesAbm.render.general_data.permisos_no_seleccionar', defaultMessage: 'El perfil tiene permisos que no se pueden seleccionar a la vez:' })}
																	<ul>
																	{this.state.permisosEliminados.map((e) => <li>{e}</li>)}
																	</ul>
																	{this.props.intl.formatMessage({ id: 'perfilesAbm.render.general_data.elija_uno', defaultMessage: 'Elija solo uno de ellos.' })}
																	</div>
																</div>
																) : ""}
															</div>
															) : ('')}
														</div>
													</div>
													{this.props.action === 'VIEW' ? (
														<div className="form-group">
															<label htmlFor="permisosDisponibles">
																<FormattedMessage id="perfilesAbm.render.general_data.permisos_disponibles" defaultMessage="Permisos Disponibles:" />
															</label>
															<input
																type="text"
																className="form-control mb-2"
																placeholder={this.props.intl.formatMessage({ id: 'perfilesAbm.render.general_data.filtros', defaultMessage: 'Filtros' })}
																onChange={e => {
																	this.setState({ permisosFiltro: e.target.value });
																}}
															/>
															<select
																size="10"
																className="form-control w-100"
																id="permisosDisponibles"
															>
																{(formData.permisos
																	.filter(permiso =>
																		!this.state.permisosFiltro ||
																		permiso.toLowerCase().includes((this.state.permisosFiltro || '').toLowerCase())
																	)
																).map(permiso => (
																	<option key={permiso} value={permiso}>
																		{getPermissionComponent(permiso, this.props.intl)}
																	</option>
																))}
															</select>
														</div>
													) : (
													<div className="form-group">
														<select multiple="multiple" size="10" ref="duallistbox" id="permisos" value={formData.permisos} onChange={this.handleFormChange}>
															{this.state.permisosDisponibles.map(function(permiso) {
															return <option key={permiso} value={permiso}>{getPermissionComponent(permiso, component.props.intl)}</option>;
														})}
														</select>
													</div>
													)}
												</div>
											</div>
										</div>
									</div>
								</div>
								{/* Seccion de asignacion de perfiles */}
								{puedeAsignarPerfiles && (
									<PerfilesAsignacion 
										ref={(ref) => this.perfilesAsignacionRef = ref}
										formData={this.state.formData}
										action={this.props.action}
										perfilesDisponibles={this.state.perfilesDisponibles}
										handlePerfilesChange={this.handlePerfilesChange}
										duallistboxRef={(ref) => this.refs.perfilesAsignablesDuallistbox = ref}
									/>
								)}
							</div>
							<div className="card pull-up">
								<div className="card-content">
									<div className="card-body">
										<div className="text-cd text-right">
											{this.props.action !== 'VIEW' && (
											<button type="submit" className="btn btn-primary mr-1" disabled={!validationState.form.valid}>
											<i className="fa fa-check-circle"></i><FormattedMessage id="perfilesAbm.finish_button.guardar" defaultMessage=" Guardar"/>
											</button>
											)}
											<button type="button" className="btn btn-danger" onClick={this.handleCancel.bind(this)}>
											<i className="fa fa-times-circle"></i> {this.props.action === 'VIEW' ? this.props.intl.formatMessage({ id: 'perfilesAbm.finish_button.volver', defaultMessage: 'Volver' }) : this.props.intl.formatMessage({ id: 'perfilesAbm.finish_button.cancelar', defaultMessage: 'Cancelar' })}
											</button>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default injectIntl(PerfilesAbm);